import { Component } from '@theme/component';
import { ThemeEvents } from './events.js';

class ProductLinksComponent extends Component {
	#selectedVariantId = null;
	#variantSpecs = null;

	connectedCallback() {
		super.connectedCallback();

		const variantSpecsJson = this.getAttribute('data-variant-specs');
		if (variantSpecsJson) {
			try {
				this.#variantSpecs = JSON.parse(variantSpecsJson);
			} catch (e) {
				console.error('Failed to parse variant specs JSON:', e);
			}
			this.#selectedVariantId = this.getAttribute('data-selected-variant-id');
			this.#renderVariantSpecs();
			this.#bindVariantEvents();
		} else {
			this.#renderSpecsTable();
		}
	}

	#bindVariantEvents() {
		const section = this.closest('.shopify-section, dialog');
		if (!section) return;

		section.addEventListener(ThemeEvents.variantUpdate, (event) => {
			const id = event.detail.resource?.id;
			if (!id) return;
			this.#selectedVariantId = String(id);
			const switcher = this.querySelector('.product-links-specs__switcher');
			if (switcher) /** @type {HTMLSelectElement} */ (switcher).value = this.#selectedVariantId;
			this.#renderVariantSpecsContent();
		});
	}

	#renderVariantSpecs() {
		const container = this.querySelector('[data-specs-content]');
		if (!container || !this.#variantSpecs?.length) return;

		let html = `<div class="product-links-specs__switcher-wrap">`;
		html += `<select class="product-links-specs__switcher">`;
		for (const v of this.#variantSpecs) {
			const selected = String(v.id) === String(this.#selectedVariantId) ? ' selected' : '';
			html += `<option value="${this.#escapeHtml(String(v.id))}"${selected}>${this.#escapeHtml(v.name)}</option>`;
		}
		html += `</select>`;
		html += `<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
		html += `</div>`;
		html += `<div class="product-links-specs__variant-content"></div>`;

		container.innerHTML = html;

		const switcher = container.querySelector('.product-links-specs__switcher');
		switcher.addEventListener('change', (e) => {
			this.#selectedVariantId = /** @type {HTMLSelectElement} */ (e.target).value;
			this.#renderVariantSpecsContent();
		});

		this.#renderVariantSpecsContent();
	}

	#renderVariantSpecsContent() {
		const contentEl = this.querySelector('.product-links-specs__variant-content');
		if (!contentEl || !this.#variantSpecs) return;

		const variant = this.#variantSpecs.find((v) => String(v.id) === String(this.#selectedVariantId));
		if (!variant) return;

		const html = Object.entries(variant.specs)
			.map(([category, entries]) => {
				const rows = Object.entries(entries)
					.map(
						([label, value]) =>
							`<div class="product-links-specs__row">
								<span class="product-links-specs__label">${this.#escapeHtml(label)}</span>
								<span class="product-links-specs__value">${this.#escapeHtml(String(value))}</span>
							</div>`
					)
					.join('');

				return `<div class="product-links-specs__category">
					<h3 class="product-links-specs__category-title">${this.#escapeHtml(this.#capitalize(category))}</h3>
					${rows}
				</div>`;
			})
			.join('');

		contentEl.innerHTML = html;
	}

	#renderSpecsTable() {
		const json = this.getAttribute('data-specifications');
		if (!json) return;

		const container = this.querySelector('[data-specs-content]');
		if (!container) return;

		try {
			const data = JSON.parse(json);
			const html = Object.entries(data)
				.map(([category, entries]) => {
					const rows = Object.entries(entries)
						.map(
							([label, value]) =>
								`<div class="product-links-specs__row">
                  <span class="product-links-specs__label">${this.#escapeHtml(label)}</span>
                  <span class="product-links-specs__value">${this.#escapeHtml(String(value))}</span>
                </div>`
						)
						.join('');

					return `<div class="product-links-specs__category">
            <h3 class="product-links-specs__category-title">${this.#escapeHtml(
							this.#capitalize(category)
						)}</h3>
            ${rows}
          </div>`;
				})
				.join('');

			container.innerHTML = html;
		} catch (e) {
			console.error('Failed to parse specifications JSON:', e);
		}
	}

	#capitalize(str) {
		return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
	}

	#escapeHtml(str) {
		const div = document.createElement('div');
		div.textContent = str;
		return div.innerHTML;
	}
}

if (!customElements.get('product-links-component')) {
	customElements.define('product-links-component', ProductLinksComponent);
}
